import { ListCell, ListCellFallback } from '@cbhq/cds-web/cells';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextLabel1, TextTitle3 } from '@cbhq/cds-web/typography';

import useBillingTiers from ':cloud/hooks/useBillingTiers';
import { MeterTier } from ':cloud/types/ts_types';
import { currencyFormatter } from ':cloud/utils/formatters/currency';

const tierStyle = { margin: 0 };

function getTierStartingUnitCopy(tier: MeterTier): string {
  return (+tier.startingUnit).toLocaleString('en-US');
}
function getTierUpperLimit(i: number, tiers: MeterTier[]): number {
  const next = tiers?.[i + 1];
  return next ? +next.startingUnit - 1 : Infinity;
}
function getTierUpperLimitCopy(i: number, tiers: MeterTier[]): string {
  return getTierUpperLimit(i, tiers) < Infinity
    ? `to ${getTierUpperLimit(i, tiers).toLocaleString('en-US')}`
    : 'and up';
}

function BillingMeterTiers() {
  const tiers = useBillingTiers();

  if (!tiers?.length) {
    return <ListCell description="Product not found" />;
  }
  return (
    <VStack as="ul" spacing={0} style={tierStyle}>
      {tiers.map((tier, i: number) => (
        <ListCell
          title={`${getTierStartingUnitCopy(tier)} ${getTierUpperLimitCopy(i, tiers)}`}
          detail={`${currencyFormatter(+tier.pricePerUnit)} each/month`}
          as="li"
          key={tier.startingUnit}
        />
      ))}
    </VStack>
  );
}

type MeterTiersProps = {
  isLoading: boolean;
};

export function MeterTiers({ isLoading }: MeterTiersProps) {
  return (
    <VStack gap={7}>
      <VStack spacingStart={3}>
        <TextTitle3 as="h3">Wallet as a Service</TextTitle3>
        <TextBody as="p" color="foregroundMuted">
          Simple and secure platform for deploying web3 wallets to your users.
        </TextBody>
      </VStack>
      <VStack>
        <TextLabel1 as="p" color="foregroundMuted" spacingStart={3}>
          Pay as you go wallets
        </TextLabel1>
        {isLoading ? (
          <VStack as="ul" spacingStart={0}>
            <ListCellFallback title detail />
            <ListCellFallback title detail />
            <ListCellFallback title detail />
          </VStack>
        ) : (
          <BillingMeterTiers />
        )}
      </VStack>
    </VStack>
  );
}
